import { AutogenLayoutResponsibilityCodeList } from "./autogen/AutogenLayoutResponsibilityCodeList";

export class ResponsibilityCodeList extends AutogenLayoutResponsibilityCodeList {

    override onLoad() {
        this.mainDataSource.search();
    }

}
